import { Navigate, useOutletContext } from "react-router-dom";
import CaseManagerAdmin from "./caseManagerAdmin";
import useRoles from "../../hooks/useRoles";
import { canAccessFeature } from "../../utils/authorization";
const Admins = () => {
  // const { user } = useOutletContext();
  // const userType = user?.type;
  // const userPosition = user?.position?.name;
  // const userRole = user?.account_role?.name;
  const { roles } = useRoles();

  // switch (userType) {
  //     case "patient":
  //         return <Navigate to="/unauthorized" replace />;
  //     case "staff_member":
  //         switch (userPosition) {
  //             case "case-manager":
  //                 return userRole === 'Super User' ? <CaseManagerAdmin /> : <Navigate to="/unauthorized" replace />;
  //             case "biller":
  //                 return userRole === 'Super User' ? <CaseManagerAdmin /> : <Navigate to="/unauthorized" replace />;
  //             case "nurse":
  //                 return userRole === 'Super User' ? <CaseManagerAdmin /> : <Navigate to="/unauthorized" replace />;
  //             default:
  //                 return <Navigate to="/unauthorized" replace />;
  //         }
  //     default:
  //         return <Navigate to="/unauthorized" replace />;
  // }
  const user= JSON.parse(localStorage.getItem("user"));
  const hasAdminAccess =  canAccessFeature(user, "pages.admin");
  
  // const hasAccess = roles.some((role) =>
  //   ["Super User", "TOCA Admin"].includes(role)|| hasAdminAccess
  // );

  return hasAdminAccess  ? (
    <CaseManagerAdmin />
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default Admins;
